import type { ReactNode } from "react";
import { BrandLogo } from "../../icons";

/** The centred sign-in layout, used for every page around signing in. */
export function AuthFrame({ children }: { children: ReactNode }) {
  return <div className="login">{children}</div>;
}

export function AuthLoading() {
  return <div className="center-msg"><p className="muted">Loading…</p></div>;
}

/** A sign-in problem explained: why, and what to do about it. */
export default function AuthScreen({ title, message, email, actions }: { title: string; message?: string; email?: string; actions?: ReactNode }) {
  return (
    <AuthFrame>
      <div className="panel" role="alert">
        <div className="login-head">
          <h1><BrandLogo className="brand-logo brand-logo-lg" /></h1>
        </div>
        <h2>{title}</h2>
        {email && <p className="small">Signed in as <b>{email}</b></p>}
        {message && <p className="small muted auth-message">{message}</p>}
        {actions && <div className="row">{actions}</div>}
      </div>
    </AuthFrame>
  );
}
